import _ from "lodash";

function getDestinationCompanyObj(companies, dispatch) {
  const destination = dispatch && dispatch.destination ? dispatch.destination : {};
  const companyId = destination.companyId;

  if (!companyId) {
    return {};
  }

  return companies[companyId] || {};
}

function isReceiveProofImageRequired(company) {
  return company.isReceiveProofImageRequired !== false;
}

function getDocumentsRequirementMessage(isRequired) {
  return isRequired
    ? "At least 1 proof image is required for this destination company."
    : "Proof images are optional for this destination company.";
}

function hasSelectedProofImages(selDocuments) {
  return _.some(selDocuments, (document) => {
    return document && !_.isEmpty(document);
  });
}

export const ReceiveDispatchUtil = {
  getDestinationCompanyObj,
  isReceiveProofImageRequired,
  getDocumentsRequirementMessage,
  hasSelectedProofImages,
};
